import { render, staticRenderFns } from "./UploadImageEP.vue?vue&type=template&id=a04165d2&scoped=true&"
import script from "./UploadImageEP.vue?vue&type=script&lang=js&"
export * from "./UploadImageEP.vue?vue&type=script&lang=js&"
import style0 from "./UploadImageEP.vue?vue&type=style&index=0&id=a04165d2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a04165d2",
  null
  
)

export default component.exports